import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';

export const TextInternationalDataTransfer = () => (
  <DynamicContent
    configPath={REMOTE_CONFIG_PATHS.PRIVACY_POLICY.INTERNATIONAL_DATA_TRANSFER}
    renderAsHtml={true}
  />
);
